import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.css";
// import Vconsole from 'vconsole';
//二维码
// import VueBarcode from 'vue-barcode';
// Vue.component('barcode', VueBarcode)
// new Vconsole();
Vue.use(Vant);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");